const colorPalette = [
  'bg-[#5ed3f3]', // A
  'bg-[#6667dd]', // B
  'bg-[#0acdba]', // C
  'bg-[#ff80b5]', // D
  'bg-[#ffb28f]', // E
  'bg-[#ffd066]', // F
  'bg-[#faa882]', // G
  'bg-[#ffd576]', // H
  'bg-[#fe93bf]', // I
  'bg-[#6162d7]', // J
  'bg-[#ffc84c]', // K
  'bg-[#2accf8]', // L
  'bg-[#4f50e1]', // M
  'bg-[#0f988a]', // N
  'bg-[#fcad89]', // O
  'bg-[#3d3edf]', // P
  'bg-[#02ccb8]', // Q
  'bg-[#ffabce]', // R
  'bg-[#15edd8]', // S
  'bg-[#86e1f9]', // T
];

export const rawColorPalette = [
  '#5ed3f3', // A
  '#6667dd', // B
  '#0acdba', // C
  '#ff80b5', // D - Uncommented for more color options
  '#ffb28f', // E - Uncommented for more color options
  '#ffd066', // F - Uncommented for more color options
  '#faa882', // G
  '#ffd576', // H
  '#fe93bf', // I
  '#6162d7', // J
  '#ffc84c', // K
  '#2accf8', // L
  '#4f50e1', // M
  '#0f988a', // N
  '#fcad89', // O
  '#3d3edf', // P
  '#02ccb8', // Q
  '#ffabce', // R
  '#15edd8', // S
  '#86e1f9', // T
  '#00cfff', // aqua tint → vivid cyan
  '#00b0ff', // light sky blue → saturated blue
  '#00acc1', // soft cyan → deep cyan
  '#2196f3', // powder blue → crisp blue
  '#3d5afe', // pastel blue → vivid blue
  '#536dfe', // soft lavender blue → electric blue
  '#5c6bc0', // muted indigo → true indigo
  '#7c4dff', // lilac → electric violet
  '#ab47bc', // lavender blush → plum
  '#9c27b0', // orchid → rich purple
  '#ec407a', // mauve → neon pink
  '#e91e63', // soft pink → raspberry
  '#f44336', // blush → vivid red
  '#ff7043', // coral peach → coral red
  '#ffa726', // pastel orange → rich orange
  '#ffca28', // soft citrus → bright yellow
  '#ffeb3b', // lemon chiffon → bright lemon
  '#d4e157', // sage yellow → spring lime
  '#aed581', // mint green → fresh mint
  '#4db6ac', // seafoam → strong teal
  '#26a69a', // teal mist → deeper teal
  '#00e5ff', // pale aqua → electric aqua
  '#00bfa5', // bright mint → saturated teal
  '#0097a7', // turquoise → strong ocean
  '#26c6da', // dusty cyan → bright cyan
  '#4fc3f7', // cool blue → sky blue
  '#5c6bc0', // bluish lavender → indigo blue
  '#7986cb', // ice violet → violet blue
  '#9fa8da', // periwinkle → lavender-blue
  '#82b1ff', // soft azure → blue tint
  '#64b5f6', // powder ice → true sky
  '#4dd0e1', // pale sky → crisp aqua
  '#b39ddb', // faint lavender → rich lavender
  '#f06292', // orchid blush → vibrant orchid
  '#f48fb1', // cotton candy pink → hot cotton
  '#ff8a65', // peach glow → tangerine pink
  '#ffb74d', // light mango → sunset gold
  '#fff176', // butter yellow → neon butter
  '#dce775', // soft lime → zesty lime
  '#81c784', // pastel mint → fresh spring green
  '#80cbc4', // mint frost → clean teal
  '#4dd0e1', // icy teal → bold cyan
  '#4fc3f7', // foggy cyan → crisp cyan
  '#7986cb', // sky frost → lavender blue
  '#9575cd', // mild periwinkle → violet
  '#ba68c8', // soft violet → deep orchid
  '#ce93d8', // rose quartz → fuchsia violet
  '#f06292', // cherry blossom → hot cherry
  '#e57373', // light rouge → warm red
  '#ff8a65', // apricot cream → fiery apricot
  '#ffb74d', // melon sorbet → mango fire
  '#fff176', // vanilla cream → golden lemon
  '#dce775', // citrus herb → citrus
  '#aed581', // misty jade → jade green
  '#80deea', // seafoam wash → radiant aqua
  '#4dd0e1', // crystal blue → sharp teal
  '#64b5f6', // baby blue → true sky
  '#7986cb', // lilac moon → electric indigo
  '#9575cd', // snow lavender → icy violet
  '#ce93d8', // light orchid → neon orchid
  '#f06292', // rosewater → bold rose
  '#ff8a65', // desert blush → sunset coral
  '#ffb74d', // lemon blush → citrus yellow
  '#fff176', // mellow yellow → bright yellow
  '#dce775', // spring green → zesty lime
  '#aed581', // pastel mint → mint glow
  '#80deea', // glacial lake → strong aqua
  '#4fc3f7', // hazy blue → clean blue
  '#9575cd', // sleepy violet → deep violet
  '#ba68c8', // dreamy lilac → vivid orchid
  '#f06292', // velvet rose → bold rose
  '#e57373', // pale cherry → lively cherry
  '#ff8a65', // light salmon → crisp coral
  '#ffb74d', // papaya tint → mango orange
  '#fff176', // lemonade fog → bright lemon
  '#dce775', // avocado ice → spring green
  '#aed581', // green milk → fresh mint
];

export function createSensorHexColorMap(sensors: string[]): Record<string, string> {
  return sensors.reduce((map, sensor, index) => {
    // Cycle through the palette if index exceeds array length
    const colorIndex = index % rawColorPalette.length;
    map[sensor] = rawColorPalette[colorIndex];
    return map;
  }, {} as Record<string, string>);
}

export function createSensorColorMap(sensors: string[]): Record<string, string> {
  return sensors.reduce((map, sensor, index) => {
    map[sensor] = colorPalette[index] || 'bg-gray-300'; // fallback for overflow
    return map;
  }, {} as Record<string, string>);
}

export function getRawColorByIndex(index: number): string {
  // Cycle through the palette if index exceeds array length
  if (rawColorPalette.length === 0) return '#cccccc'; // Safety check
  const colorIndex = index % rawColorPalette.length;
  return rawColorPalette[colorIndex];
}

export function getTailwindColorByIndex(index: number): string {
  return colorPalette[index] || 'bg-gray-300'; // fallback
}
